import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { SharedModule } from '../shared/shared.module';
import { DrDishChangePasswordSentComponent } from './dr-dish-change-password-sent/dr-dish-change-password-sent.component';
import { DrDishForgotPasswordComponent } from './dr-dish-forgot-password/dr-dish-forgot-password.component';
import { DrDishInputComponent } from './dr-dish-input/dr-dish-input.component';
import { DrDishLoginComponent } from './dr-dish-login/dr-dish-login.component';
import { DrDishPasswordInputComponent } from './dr-dish-password-input/dr-dish-password-input.component';
import { DrDishRegisterResendComponent } from './dr-dish-register-resend/dr-dish-register-resend.component';
import { DrDishRegisterSendComponent } from './dr-dish-register-send/dr-dish-register-send.component';
import { DrDishRegisterComponent } from './dr-dish-register/dr-dish-register.component';
import { DrDishResetPasswordComponent } from './dr-dish-reset-password/dr-dish-reset-password.component';
import { DrDishUnblockComponent } from './dr-dish-unblock/dr-dish-unblock.component';
import { DrDishComponent } from './dr-dish/dr-dish.component';

@NgModule({
  declarations: [
    DrDishComponent,
    DrDishLoginComponent,
    DrDishRegisterComponent,
    DrDishUnblockComponent,
    DrDishInputComponent,
    DrDishRegisterSendComponent,
    DrDishRegisterResendComponent,
    DrDishForgotPasswordComponent,
    DrDishResetPasswordComponent,
    DrDishChangePasswordSentComponent,
    DrDishPasswordInputComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    AppRoutingModule,
    FormsModule,
    SharedModule,
  ],
  exports: [
    DrDishComponent,
    DrDishRegisterResendComponent,
    DrDishInputComponent,
    DrDishResetPasswordComponent,
    DrDishRegisterSendComponent,
    DrDishUnblockComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DrDishModule {}
